/* globals Store */
import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import {UploadFile} from '@/vue-dlb/models'
import {DownloadFile} from '@/vue-dlb/models'
import appUtil from '@/vue-dlb/utils/app-util'
import { compareSort } from '@/vue-dlb/common/common';

import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import { isEmptyProcessWindowList, changeProcessShareFlag, compareTableData } from '@/vue-caas/utils/process';

const setupURI = config.setupApiUrl;
const isDlbMybatis = config.isDlbMybatis;

import {
  handleResponseError,
  alertSuccess,
  closeAlert,
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
  selectUserDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get, map } from "lodash";

const state = {
  mapList: [],
  mapListSource: [],
  mapDataList: [],
  appliedList: [],
  scannerList: [],
  mapperList: [],
  mapData: [],
  mapListSMLK: [],
  mapItemSMLK: [],
  mapDefinitionList:[],
  codeListResult: [],
  mapSortList: [],
  mapFilterList: [],
  mapPagingList: [],
  mapChange: {},
};

const getters = {
  mapListSMLK: state => state.mapListSMLK,
  mapChange: state => state.mapChange,
};

const actions = {
  queryList: async ({ commit }, searchItems) => {
    const retSet1 = new ObjDataSet("mapList");
    const retSet2 = new ObjDataSet("appliedList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet1);
    trSet.AddDataSet("O", "DS03", retSet2);
    trSet.tranID = "DS02:EDP_MAP_LIST_MAN_MAP_MST_FN|DS03:EDP_MAP_LIST_MAN_MAP_SRM_LST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(async response => {
      commitRetDataSets(commit, response.data);
    });
  },
  updateLock: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("updateLock");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapManManager";
      trSet.tranMethod = "updateLock";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_MAP_UPD_MAN_MAP_LOCK_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  queryScannerHistoryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("scannerList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryScannerHistoryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MAP_LIST_MAN_MAP_SCAN_HST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryMapperHistoryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mapperList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryMapperHistoryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MAP_LIST_MAN_MAP_MAPP_HST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryMappingDefinitionList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mapDefinitionList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryMappingDefinitionList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MAP_LIST_MAN_MPD_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  getMapInfo: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mapData");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getMapInfo");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MAP_LIST_MAN_MAP_MST_MOD_FN";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  modifyMapInfo: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("modifyMapInfo");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapManManager";
      trSet.tranMethod = "modifyMap";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_MAP_UPD_MAN_MAP_MST_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  saveAddMap: async ({ commit }, paramItems) => {
    showProgress("Please stand by");
    // Local에서 업로드 하는 파일들이(Mapper, Scanner)있을 경우 먼저 서버에 업로드 한다. 이건 일단 임시로 썼음.
    // 나중에 화면쪽에 server load로 바꾸면 아래 if구문 지우면 됨.
    // Server의 Workspace에서 작성중인 파일을 Copy해 온다.
    // Mapper File Upload
    if(paramItems.data[0].mappfile != null)
    {
      let uploadmapp = new UploadFile();
      uploadmapp.data[0].DIV_KUBUN = 'ASSET';
      uploadmapp.data[0].BIZ_KUBUN = 'SAVE_MAP';
      uploadmapp.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
      uploadmapp.data[0].USER_KUBUN = $cookies.get('user-id');
      uploadmapp.data[0].SUB_DIR = paramItems.data[0].MAP_NAME;
      uploadmapp.data[0].RENAME_YN = 'Y';
      uploadmapp.data[0].FILE_NAME = paramItems.data[0].mappfile.name;
      uploadmapp.data[0].file = paramItems.data[0].mappfile;
      // Upload Mapper File
      const retSet = new ObjDataSet("UploadedFile");
      let condSet = new ObjDataSet("condSet");
      let trSet = new ObjTrSet("saveAddMap");
      condSet = appUtil.addDataHeader(uploadmapp, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.AddDataSet("O", "DS02", retSet);
      trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
      const formData = new FormData();
      formData.append('file', uploadmapp.data[0].file, uploadmapp.data[0].FILE_NAME);
      formData.append('trSet', JSON.stringify(trSet));
      await api.trFileSend("Fileupload", formData).then(res => {
        let resdata = res.data;
        var trset = JSON.parse(JSON.stringify(resdata));
        var datasets = trset.DataSets;
        var datarows = datasets[0].DataRows;
        //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
        paramItems.data[0].MAPPER_FILE_ID = datarows[0].FILE_NAME;  // FlatFile Layout Excel Server file ID
        paramItems.data[0].MAPPER_SIZE = datarows[0].FILE_BYTE;  // FlatFile Layout Excel Server file Size
        paramItems.data[0].MAPPER_NAME = paramItems.data[0].mappfile.name;  // FlatFile Layout File Name
      });
    }// if scanner file exist

    if(paramItems.data[0].scanfile != null)
    {
      // Scanner File Upload
      let uploadscan = new UploadFile();
      uploadscan.data[0].DIV_KUBUN = 'ASSET';
      uploadscan.data[0].BIZ_KUBUN = 'SAVE_MAP';
      uploadscan.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
      uploadscan.data[0].USER_KUBUN = $cookies.get('user-id');
      uploadscan.data[0].SUB_DIR = paramItems.data[0].MAP_NAME;
      uploadscan.data[0].RENAME_YN = 'Y';
      uploadscan.data[0].FILE_NAME = paramItems.data[0].scanfile.name;
      uploadscan.data[0].file = paramItems.data[0].scanfile;
      // Upload FlatFile Layout File Data
      const retSet2 = new ObjDataSet("UploadedFile");
      let condSet2 = new ObjDataSet("condSet");
      let trSet2 = new ObjTrSet("saveAddMap");
      condSet2 = appUtil.addDataHeader(uploadscan, condSet2);
      trSet2.AddDataSet("I", "DS01", condSet2);
      trSet2.AddDataSet("O", "DS02", retSet2);
      trSet2 = selectUserDataSet(trSet2);   // call directly only for uploading file.
      const formData2 = new FormData();
      formData2.append('file', uploadscan.data[0].file, uploadscan.data[0].FILE_NAME);
      formData2.append('trSet', JSON.stringify(trSet2));
      await api.trFileSend("Fileupload", formData2).then(res => {
        let resdata = res.data;
        var trset = JSON.parse(JSON.stringify(resdata));
        var datasets = trset.DataSets;
        var datarows = datasets[0].DataRows;
        //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
        paramItems.data[0].SCANNER_FILE_ID = datarows[0].FILE_NAME;  // FlatFile Layout CSV Server file ID
        paramItems.data[0].SCANNER_SIZE = datarows[0].FILE_BYTE;  // FlatFile Layout Excel Server file Size
        paramItems.data[0].SCANNER_NAME = paramItems.data[0].scanfile.name;  // CSV File Name
      });
    }// if scanner file exist

    // Load From Server일 경우 파일을 Copy하기 위해 서버에 디렉토리 설정을 위해 UploadFile객체 같이 보내기
    /// Insert Data
    let uploadfile = new UploadFile();
    uploadfile.data[0].DIV_KUBUN = 'ASSET';
    uploadfile.data[0].BIZ_KUBUN = 'SAVE_MAP';
    uploadfile.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
    uploadfile.data[0].USER_KUBUN = $cookies.get('user-id');
    uploadfile.data[0].SUB_DIR = paramItems.data[0].MAP_NAME;
    uploadfile.data[0].RENAME_YN = 'Y';
    uploadfile.data[0].FILE_NAME = '';
    uploadfile.data[0].file = '';
    let fileSet = new ObjDataSet("fileSet");
    fileSet = appUtil.addDataHeader(uploadfile, fileSet);
    /////////////////////////
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("saveAddMap");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.AddDataSet("I", "DS02", fileSet);
    trSet3.tranID = "MapManManager";
    trSet3.tranMethod = "saveAddMap";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },

  saveCurrentVer: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveCurrentVer");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "MapManManager";
    trSet.tranMethod = "saveCurrentVer";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteMap: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteMap");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "MapManManager";
    trSet.tranMethod = "deleteMap";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteSelectedHistory: async ({ commit }, paramItems) => {
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("deleteSelectedHistory");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.tranID = "MapManManager";
    trSet3.tranMethod = "deleteMapHistory";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },

  checkInMap: async ({ commit }, paramItems) => {
    // Map File Upload
    if(paramItems.data[0].file != null)
    {
      let uploadfile = new UploadFile();
      uploadfile.data[0].DIV_KUBUN = 'ASSET';
      uploadfile.data[0].BIZ_KUBUN = 'SAVE_MAP';
      uploadfile.data[0].SITE_CODE = $cookies.get('comp-id');
      uploadfile.data[0].USER_KUBUN = $cookies.get('user-id');
      uploadfile.data[0].SUB_DIR = paramItems.data[0].MAP_NAME;
      uploadfile.data[0].RENAME_YN = 'Y';
      uploadfile.data[0].FILE_NAME = paramItems.data[0].MAP_FILE_NAME;
      uploadfile.data[0].file = new Blob([paramItems.data[0].file], { type: 'application/text' });    // Change to blob data
      // uploadfile.data[0].file = paramItems.data[0].file;
      // Upload Mapper File
      const retSet = new ObjDataSet("UploadedFile");
      let condSet = new ObjDataSet("condSet");
      let trSet = new ObjTrSet("saveCheckinMap");
      condSet = appUtil.addDataHeader(uploadfile, condSet);
      trSet.AddDataSet("I", "DS01", condSet);
      trSet.AddDataSet("O", "DS02", retSet);
      trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
      const formData = new FormData();
      formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
      formData.append('trSet', JSON.stringify(trSet));
      await api.trFileSend("Fileupload", formData).then(res => {
        let resdata = res.data;
        var trset = JSON.parse(JSON.stringify(resdata));
        var datasets = trset.DataSets;
        var datarows = datasets[0].DataRows;
        //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
        paramItems.data[0].MAP_FILE_ID = datarows[0].FILE_NAME;  // FlatFile Layout Excel Server file ID
        paramItems.data[0].MAP_FILE_SIZE = datarows[0].FILE_BYTE;  // FlatFile Layout Excel Server file Size
        // paramItems.data[0].MAPPER_NAME = paramItems.data[0].mappfile.name;  // FlatFile Layout File Name
      });
    }

    // Load From Server일 경우 파일을 Copy하기 위해 서버에 디렉토리 설정을 위해 UploadFile객체 같이 보내기
    /// Insert Data
    let copyfile = new UploadFile();
    copyfile.data[0].DIV_KUBUN = 'ASSET';
    copyfile.data[0].BIZ_KUBUN = 'SAVE_MAP';
    copyfile.data[0].SITE_CODE = $cookies.get('comp-id');
    copyfile.data[0].USER_KUBUN = $cookies.get('user-id');
    copyfile.data[0].SUB_DIR = paramItems.data[0].MAP_NAME;
    copyfile.data[0].RENAME_YN = 'Y';
    copyfile.data[0].FILE_NAME = paramItems.data[0].MAP_FILE_NAME;
    copyfile.data[0].file = '';
    let fileSet = new ObjDataSet("fileSet");
    fileSet = appUtil.addDataHeader(copyfile, fileSet);
    /////////////////////////
    let condSet3 = new ObjDataSet("condSet");
    const trSet3 = new ObjTrSet("saveAddMap");
    condSet3 = appUtil.addDataHeader(paramItems, condSet3);
    trSet3.AddDataSet("I", "DS01", condSet3);
    trSet3.AddDataSet("I", "DS02", fileSet);
    trSet3.tranID = "MapManManager";
    trSet3.tranMethod = "checkInMap";
    const reqdata = callByDataSet(trSet3);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  //////////////////  call by SmartLink Caas ///////////////////////
  queryMapListByProcSetup: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mapListSMLK");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryMapListByProcSetup");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_SMLK_LIST_MAN_MAP_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  queryMapItemByProcSetup: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mapItemSMLK");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryMapListByProcSetup");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_SMLK_GET_MAN_MAP_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  createCodeList: async ({ commit }, paramItems) => {
    const retSet = new ObjDataSet("codeListResult");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("createCodeList");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "MapManManager";
    trSet.tranMethod = "createCodeList";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
};

const mutations = {
  mapList (state, datarows) {
    if (JSON.stringify(state.mapListSource) !== JSON.stringify(datarows) && !isEmptyProcessWindowList()) {
      changeProcessShareFlag('MAP');
    }
    state.mapList = [...datarows];
    state.mapListSource = [...datarows];
  },
  mapListSMLK (state, datarows) {
    state.mapChange = compareTableData(state.mapListSMLK, datarows, "MAP_PRCS_NO");
    state.mapListSMLK = datarows;
  },
  mapItemSMLK (state, datarows) {
    state.mapItemSMLK = datarows;
  },
  'SET_MAP_FILTER' (state, filter) {
    let datarows = state.mapListSource;
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item =>  {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.mapList = listResult;
  },
  appliedList (state, datarows) {
    state.appliedList = datarows;
  },
  scannerList (state, datarows) {
    state.scannerList = datarows;
  },
  mapperList (state, datarows) {
    state.mapperList = datarows;
  },
  mapData (state, datarows) {
    state.mapData = datarows;
  },
  mapDefinitionList(state,datarows){
    state.mapDefinitionList=datarows;
  },
  codeListResult (state, datarows) {
    state.codeListResult = datarows;
  },
  // 2021.7.30 203728 SPKA-165 Paging, sort & filter for Mapper list
  sortMapList (state, colSort) {
    let datarows = [...state.mapListSource];
    if (state.filter && state.filter.str !== '') {
      datarows = [...state.mapFilterList];
    }
    let {col, sort} = colSort;
    state.sort = {
      type: sort
    };
    if (sort === 'reset') {
      state.mapList = [...state.mapListSource];
      state.mapSortList = [...state.mapListSource];
      if (state.filter && state.filter.str !== '') {
        state.mapList = [...state.mapFilterList];
        state.mapSortList = [...state.mapFilterList];
      }
      return;
    }

    datarows.sort((a ,b) => {
      return compareSort(a[col], b[col], sort);
    });

    state.mapList = [...datarows];
    state.mapSortList = [...datarows];
  },
  setDataPaging (state, paging) {
    let mapList = [...state.mapListSource];
    if (paging.mapTypeList === 'filter') {
      // console.log("setDataPaging filter", state.mapFilterList)
      mapList = [...state.mapFilterList];
    }
    if (paging.mapTypeList === 'sort') {
      // console.log("setDataPaging sort", state.mapSortList)
      mapList = [...state.mapSortList];
    }
    state.mapPagingList = [...mapList];
    let data = mapList.slice((paging.page-1)*paging.item, (paging.page)*paging.item);
    state.mapList = [...data];
    state.mapDataList = [...data];
    // console.log("setDataPaging", state.mapList)
  },
  'SET_DATA_PER_PAGE' (state, paging) {
    let data = state.mapPagingList.slice((paging.page-1)*paging.item, (paging.page)*paging.item);
    state.mapList = [...data];
  },
  'SET_MAP_FILTER_PAGE' (state, filter) {
    let datarows = [...state.mapListSource];
    if (state.sort && state.sort.type !== 'reset') {
      datarows = [...state.mapSortList];
    }
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        state.mapList = [...state.mapListSource];
        state.mapFilterList = [...state.mapListSource];
        if (state.sort && state.sort.type !== 'reset') {
          state.mapList = [...state.mapSortList];
          state.mapFilterList = [...state.mapSortList];
        }
        return;
      }
      listResult = datarows.filter(item =>  {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.mapList = [...listResult];
    state.mapFilterList = [...listResult];
  },
  'RESET_FILTER_AND_SORT' (state) {
    if (state.sort) {
      state.sort.type = 'reset';
    }
    if (state.filter) {
      state.filter.str = '';
    }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
